import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import axios from "axios";
import logo from "./../recursos/logo-diferente.png";
import Container from "@mui/material/Container";
import { Grid } from "@mui/material";
import Logo from "../componentes/Logo";
import PasswordInput from "../componentes/PasswordInput";
import Button from '@mui/material/Button';
import bcrypt from 'bcryptjs'
const NuevaContrasena = () => {
  const [searchParams] = useSearchParams();
  const navigation = useNavigate();
  console.log(searchParams.get("token"));
  const [token, setToken] = useState();
  const [email, setEmail] = useState();
  const [mensajeerror, setMensajeerror] = useState();
  const [mensajecorrecto, setMensajecorrecto] = useState();
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [errores, setErrores] = useState([])
  const validar = () => {
    let errors = {};
    let isValid = true;
    const isValidPassword = /^(?=.*?[0-9])(?=.*?[A-Za-z]).{8,32}$/;
    console.log(errors, password, confirmpassword)
    if (password == "") {
      isValid = false
      errors.password = "La contraseña no puede estar en blanco"
    }
    if(!isValidPassword.test(password)){
      isValid = false
      errors.password = "La contraseña debe contener al menos 8 caracteres, al menos un número y al amenos una letra"
      
    }
    if (confirmpassword == "") {
      isValid = false
      errors.confirmpassword = "Debes confirmar tu contraseña"
    }
    if(!isValidPassword.test(confirmpassword)){
      isValid = false
      errors.confirmpassword = "La contraseña debe contener al menos 8 caracteres, al menos un número y al amenos una letra"
      
    }
    if (typeof password !== "undefined" && typeof confirmpassword !== "undefined") {

      if (password != confirmpassword) {
        isValid = false;
        errors.password = "Las contraseñas no coinciden";
      }
    }
    console.log(errors, password, confirmpassword)
    setErrores(errors)
    return isValid


  }
  const enviar = () => {
    if (validar()) {
      const salt = bcrypt.genSaltSync(10)
      let hashedPassword = bcrypt.hashSync(password, '$2a$10$CwTycUXWue0Thq9StjUM0u')
      hashedPassword=hashedPassword.replace(/^\$2a(.+)$/i, '$2y$1')
      console.log(hashedPassword)
      let config = {
        headers: {
          clave: "ee5c6838-a67e-4b99-ab7e-cf8e14721543",
        },
      };
      axios
        .post(
          "https://clientes.diferente.es/api/appmovil/login/guardarpassword",
          {
            token: searchParams.get("token"),
            password:password,
          },
          config
        )
        .then((respuesta) => {
          console.log(respuesta);
          if (respuesta.data.message == "Contraseña guardada correctamente") {
            setMensajecorrecto(respuesta.data.message)
           
          }
        })
        .catch((err) => {
          console.log(err.response.data);
          setMensajeerror(err.response.data.message);
        });


      // alert('Sin errores');
    }
  }
  useEffect(() => {
    const comprobarToken = async () => {
      if (searchParams.get("token")) {
        let config = {
          headers: {
            clave: "ee5c6838-a67e-4b99-ab7e-cf8e14721543",
          },
        };
        axios
          .post(
            "https://clientes.diferente.es/api/appmovil/login/verificartokenemail",
            {
              token: searchParams.get("token"),
            },
            config
          )
          .then((respuesta) => {
            console.log(respuesta);
            if (respuesta.data.message == "Token válido") {
              setToken(searchParams.get("token"));
              setEmail(respuesta.data.email);
            }
          })
          .catch((err) => {
            console.log(err.response.data);
            setMensajeerror(err.response.data.message);
          });

        // setToken(searchParams.get("token"));
      } else {
        navigation("/");
      }
    };
    comprobarToken();
  }, []);
  return (
    <Container 
    maxWidth="lg"
    sx={{ bgcolor: "#ffe6f4", height: "100%" }}
    >
      <Grid
        container
        item
        flexDirection={"column"}
        justifyContent={"flex-start"}
        alignItems={"center"}
        padding={'10'}
       
      >
        <Logo />
        {token && (
          <>
            {token}
            <p>Por favor introduce tu contraseña</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "1rem 0",
              }}
            >

              <PasswordInput
                password={password}
                handlePassword={

                  (e) => {
                    setPassword(e.target.value)
                    setErrores([])
                  }
                }
                fallo={errores.password}
              />
            </div>
            <p>Por favor confirma tu contraseña</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "2rem 0",
              }}
            >
              <PasswordInput
                password={confirmpassword}
                handlePassword={(e) => {
                  setConfirmPassword(e.target.value)
                  setErrores([])
                }}
                fallo={errores.confirmpassword}

              />




            </div>
            <Button
              onClick={() => {
                enviar()
              }}
              variant="contained">Enviar</Button>
            {/* <div>NuevaContrasena</div> */}
          </>
        )}
        {mensajeerror && (
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              navigation("/");
            }}
          >
            {mensajeerror}
          </Alert>
        )}
          {mensajecorrecto && (
          <Alert
            variant="filled"
            severity="succes"
            onClose={() => {
              navigation(0);
            }}
          >
            {mensajecorrecto}
          </Alert>
        )}
      </Grid>
    </Container>
  );
};

export default NuevaContrasena;
